import request from '@/utils/requestPdf'

export default {
  
  reportPreviews(parameter) {
    return request({
        url: 'epi/reportParamPreviews',
        method: 'get',
        params: parameter
      })
  },

  batchPrint(parameter) {
    return request({
        url: 'epi/batchPrint',
        method: 'get',
        params: parameter,
        responseType: 'blob',
      })
  },
  
  sampleImage(parameter) {
    return request({
        url: 'epi/sampleImage',
        method: 'get',
        params: parameter,
        responseType: 'blob',
        headers:{ 'Content-Type': 'application/json; application/octet-stream'},
      })
  },
}
